<template>
  <b-modal
    id="modal-create-package"
    title="Tạo mới gói dịch vụ"
    centered
    hide-footer
    @hidden="resetModal"
  >
    <b-overlay :show="loading">
      <form @submit.prevent="handleValidate">
        <basic-input
          label="Mã gói"
          placeholder="Nhập mã gói"
          :value.sync="form.code"
          maxlength="50"
          required
          name="code"
          v-validate="'required|max:50'"
          :state="validateState('code')"
          :invalidFeedback="errors.first('code')"
          data-vv-as="Mã gói"
        />
        <basic-input
          label="Tên gói"
          placeholder="Nhập tên gói"
          :value.sync="form.name"
          maxlength="255"
          required
          name="name"
          v-validate="'required|max:255'"
          :state="validateState('name')"
          :invalidFeedback="errors.first('name')"
          data-vv-as="Tên gói"
        />
        <b-row>
          <b-col>
            <basic-input
              label="Thời hạn"
              placeholder="Nhập thời hạn"
              input-number
              maxlength="4"
              v-model="form.duration"
              required
              name="duration"
              v-validate="'required|more_than_zero'"
              :state="validateState('duration')"
              :invalidFeedback="errors.first('duration')"
              data-vv-as="Thời hạn"
            />
          </b-col>
          <b-col>
            <basic-select
              label="Đơn vị"
              placeholder="--- Chọn đơn vị ---"
              :options="durationTypes"
              value-label="text"
              track-by="value"
              :allowEmpty="false"
              :value.sync="form.durationType"
              name="durationType"
            />
          </b-col>
        </b-row>
        <basic-input
          label="Giá bán"
          placeholder="Nhập giá bán"
          input-number
          maxlength="12"
          v-model="form.price"
          name="price"
        />
        <basic-text-area
          label="Mô tả"
          placeholder="Nhập mô tả"
          :value.sync="form.description"
          name="description"
        />
        <b-form-checkbox v-model="form.isRoadmap" class="mt-4">
          Gói có lộ trình
        </b-form-checkbox>

        <div class="d-flex justify-content-end align-items-center mt-6">
          <b-button class="btn mr-2" type="button" @click="onClickCancel">
            Hủy
          </b-button>
          <b-button class="btn btn-success ml-3" type="submit" :disabled="loading">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
            </span>
            Lưu lại
          </b-button>
        </div>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalCreatePackage',
  data() {
    return {
      loading: false,
      form: {
        code: null,
        name: null,
        duration: null,
        durationType: 1,
        price: null,
        description: null,
        isRoadmap: true,
      },
      durationTypes: [
        { text: 'Ngày', value: 0 },
        { text: 'Tuần', value: 1 },
        { text: 'Tháng', value: 2 },
      ],
    };
  },
  methods: {
    resetModal() {
      this.form = {
        code: null,
        name: null,
        duration: null,
        durationType: 1,
        price: null,
        description: null,
        isRoadmap: true,
      };
      this.$validator.reset();
    },
    onClickCancel() {
      this.$bvModal.hide('modal-create-package');
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    handleValidate() {
      this.$validator.validateAll().then((result) => {
        if (!result) return;
        this.handleSubmit();
      });
    },
    async handleSubmit() {
      try {
        this.loading = true;
        const payload = {
          code: this.form.code?.trim(),
          name: this.form.name?.trim(),
          duration: Number(this.form.duration),
          durationType: this.form.durationType,
          isRoadmap: this.form.isRoadmap,
          description: this.form.description,
          price: this.form.price ? Number(this.form.price) : null,
        };

        const { meta, data, error } = await this.$api.post('/Package', payload, {
          headers: { 'Content-Type': 'application/json' },
        });

        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message || 'Không tạo được gói dịch vụ.',
          });
        }

        this.$toastr.s({
          title: 'Thành công !',
          msg: 'Tạo mới gói dịch vụ thành công.',
        });
        this.$emit('created', data);
        this.$bvModal.hide('modal-create-package');
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message || 'Không tạo được gói dịch vụ.',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
